<template>
    <div class="page">
        <ion-grid fixed>
            <form @keyup.enter="saveCharger">
                <ion-row class="row-divider"></ion-row>
                <ion-row class="rectangle">
                    <ion-col>
                        <ion-row align-items-stretch>
                            <ion-col class="col-padding">
                                <ion-label class="section-head">Basic Details</ion-label>
                            </ion-col>
                        </ion-row>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">Charger ID</ion-label>
                                <div class="border-line-34 margin-top-10 readonly">
                                    <ion-input
                                    class="form-input"
                                    type="text"
                                    @input="id = $event.target.value"
                                    :value="id"
                                    readonly="true"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">
                                    Manufacturer
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-input
                                    class="form-input"
                                    type="text"
                                    placeholder="Enter Manufacturer"
                                    @input="manufacturer = $event.target.value"
                                    :value="manufacturer"
                                    maxlength="100"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">
                                    Serial No
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-input
                                    class="form-input"
                                    type="text"
                                    placeholder="Enter Serial Number"
                                    @input="serialNumber = $event.target.value"
                                    :value="serialNumber"
                                    maxlength="100"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">
                                    Charger Type
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-select
                                    class="form-select select-mobile"
                                    :value="type"
                                    @ionChange="changeChargerType($event)"
                                    placeholder="Select Type"
                                    interface="action-sheet"
                                    >
                                    <!-- Below code is commented by vinoth 28.10.2024 as per siva sir request -->
                                    <!-- <ion-select-option
                                        v-for="(type, index) in this.types"
                                        :key="index"
                                        :value="type.id"
                                    >{{type.name}}</ion-select-option>
                                    </ion-select> -->
                                    <ion-select-option
                                        v-for="(type, index) in this.types"
                                        :key="index"
                                        :value="type.id"
                                    >{{type.id}}</ion-select-option>
                                    </ion-select>

                                    <select
                                    class="input-select select-web"
                                    v-model="type"
                                    @change="changeChargerType($event)"
                                    placeholder="Select Type"
                                    >
                                    <!-- Below code is commented by vinoth 28.10.2024 as per siva sir request -->
                                    <!-- <option
                                        v-for="(type, index) in this.types"
                                        :key="index"
                                        :value="type.id"
                                    >{{type.name}}</option> -->
                                    <option
                                        v-for="(type, index) in this.types"
                                        :key="index"
                                        :value="type.id"
                                    >{{type.id}}</option>
                                    </select>
                                </div>
                            </ion-col>
                        </ion-row>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">Input Voltage</ion-label>
                                <div class="border-line-34 margin-top-10 readonly">
                                    <ion-input
                                    class="form-input"
                                    type="text"
                                    :value="chargerType ? chargerType.inputVoltage : ''"
                                    readonly="true"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">Input Phase</ion-label>
                                <div class="border-line-34 margin-top-10 readonly">
                                    <ion-input
                                    class="form-input"
                                    type="text"
                                    :value="chargerType ? chargerType.inputPhase : ''"
                                    readonly="true"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">
                                    Primary Communication Method
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-select
                                        class="form-select select-mobile"
                                        :value="primaryCommunicaiton"
                                        @ionChange="primaryCommunicaiton = $event.target.value"
                                        placeholder="Select"
                                        interface="action-sheet"
                                    >
                                        <ion-select-option
                                            v-for="(communication, index) in this.communicationMethods"
                                            :key="index"
                                            :value="communication.id"
                                        >{{communication.name}}</ion-select-option>
                                    </ion-select>
                                    <select
                                        class="input-select select-web"
                                        v-model="primaryCommunicaiton"
                                        placeholder="Select"
                                    >
                                        <option
                                            v-for="(communication, index) in this.communicationMethods"
                                            :key="index"
                                            :value="communication.id"
                                        >{{communication.name}}</option>
                                    </select>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">
                                    Secondary Communication Method
                                    <span class="required">*</span>
                                </ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-select
                                    class="form-select select-mobile"
                                    :value="secondaryCommunicaiton"
                                    @ionChange="secondaryCommunicaiton = $event.target.value"
                                    placeholder="Select"
                                    interface="action-sheet"
                                    >
                                    <ion-select-option
                                        v-for="(communication, index) in this.communicationMethods"
                                        :key="index"
                                        :value="communication.id"
                                    >{{communication.name}}</ion-select-option>
                                    </ion-select>

                                    <select
                                    class="input-select select-web"
                                    v-model="secondaryCommunicaiton"
                                    placeholder="Select"
                                    >
                                    <option
                                        v-for="(communication, index) in this.communicationMethods"
                                        :key="index"
                                        :value="communication.id"
                                    >{{communication.name}}</option>
                                    </select>
                                </div>
                            </ion-col>
                        </ion-row>
                        <ion-row align-items-stretch>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">Charger Output Type</ion-label>
                                <div class="border-line-34 margin-top-10 readonly">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        :value="chargerType ? chargerType.chargerOutputType : ''"
                                        readonly="true"
                                    ></ion-input>
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">
                                    Pending From
                                </ion-label>
                                <div class="date-picker-box margin-top-10 datepicker-web">
                                    <datepicker
                                        class="form-vue-picker"
                                        placeholder="DD/MON/YYYY"
                                        inputFormat="dd/MMM/yyyy"
                                        v-model="pndEffectiveOn"
                                        :typeable="true"
                                    ></datepicker>
                                    <span class="custom-calendar-icon">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                    </span>
                                </div>
                                <div class="border-line-34 margin-top-10 datepicker-mobile">
                                    <!-- <div class="input-icon-calendar"> -->
                                        <!-- <ion-datetime
                                            class="form-select"
                                            placeholder="Select Date"
                                            displayFormat="YYYY, MM, DD"
                                            @ionChange="pndEffectiveOn = $event.target.value"
                                            :value="pndEffectiveOn"
                                        ></ion-datetime> -->
                                        <datepicker
                                            class= "form-select"
                                            placeholder= "Select Date"
                                            inputFormat="MMM dd, yyyy"
                                            v-model= "pndEffectiveOn"
                                            :typeable= "true"
                                        ></datepicker>
                                        <span class="input-icon-calendar">
                                            <img src="/../assets/images/common/datepicker/calendar.png" />
                                        </span>
                                    <!-- </div> -->
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">
                                    Retired On
                                </ion-label>
                                <div class="date-picker-box margin-top-10 datepicker-web">
                                    <datepicker
                                        class="form-vue-picker"
                                        placeholder="DD/MON/YYYY"
                                        inputFormat="dd/MMM/yyyy"
                                        v-model="retEffectiveOn"
                                        :typeable="true"
                                    ></datepicker>
                                    <span class="custom-calendar-icon">
                                    <img src="/../assets/images/common/datepicker/calendar.png" />
                                    </span>
                                </div>
                                <div class="border-line-34 margin-top-10 datepicker-mobile">
                                    <!-- <div class="input-icon-calendar"> -->
                                    <!-- <ion-datetime
                                        class="form-select"
                                        placeholder="Select Date"
                                        displayFormat="YYYY, MM, DD"
                                        @ionChange="retEffectiveOn = $event.target.value"
                                        :value="retEffectiveOn"
                                    ></ion-datetime> -->
                                    <datepicker
                                        class= "form-select"
                                        placeholder= "Select Date"
                                        inputFormat="MMM dd, yyyy"
                                        v-model= "retEffectiveOn"
                                        :typeable= "true"
                                    ></datepicker>
                                    <span class="input-icon-calendar">
                                        <img src="/../assets/images/common/datepicker/calendar.png" />
                                    </span>
                                    <!-- </div> -->
                                </div>
                            </ion-col>
                            <ion-col size="12" size-md="3" class="col-padding">
                                <ion-label class="section-item" position="stacked">
                                    Status
                                </ion-label>
                                <div class="border-line-34 margin-top-10">
                                    <ion-select
                                        class="form-select select-mobile"
                                        :value="status"
                                        @ionChange="status = $event.target.value"
                                        placeholder="Select Status"
                                        interface="action-sheet"
                                    >
                                        <ion-select-option
                                            v-for="(status, index) in statuses"
                                            :key="index"
                                            :value="status.id"
                                        >{{status.name}}</ion-select-option>
                                    </ion-select>

                                    <select
                                        class="input-select select-web"
                                        v-model="status"
                                        placeholder="Select Status"
                                    >
                                    <option
                                        v-for="(status, index) in statuses"
                                        :key="index"
                                        :value="status.id"
                                    >{{ status.name }}</option>
                                    </select>
                                </div>
                            </ion-col>
                        </ion-row>
                        <hr />
                        <div v-for="(output, index) in outputs" :key="index">
                            <ion-row align-items-stretch>
                                <ion-col class="col-padding">
                                    <ion-label class="section-head">Output {{index + 1}}</ion-label>
                                </ion-col>
                            </ion-row>
                            <ion-row align-items-stretch>
                                <ion-col size="12" size-md="3" class="col-padding">
                                    <ion-label class="section-item" position="stacked">
                                        Output Type
                                    </ion-label>
                                    <div class="border-line-34 margin-top-10 readonly">
                                        <ion-input
                                            class="form-input"
                                            type="text"
                                            :value="output.type.outputType"
                                            readonly="true"
                                        ></ion-input>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="3" class="col-padding">
                                    <ion-label class="section-item" position="stacked">Output Voltage</ion-label>
                                    <div class="border-line-34 margin-top-10 readonly">
                                    <ion-input
                                        class="form-input"
                                        type="text"
                                        :value="output.type.volt"
                                        readonly="true"
                                    ></ion-input>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="3" class="col-padding">
                                    <ion-label class="section-item" position="stacked">Output KW Start</ion-label>
                                    <div class="border-line-34 margin-top-10 readonly">
                                        <ion-input
                                            class="form-input"
                                            type="text"
                                            :value="output.type.kwRange.start"
                                            readonly="true"
                                        ></ion-input>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="3" class="col-padding">
                                    <ion-label class="section-item" position="stacked">Output KW End</ion-label>
                                    <div class="border-line-34 margin-top-10 readonly">
                                        <ion-input
                                            class="form-input"
                                            type="text"
                                            :value="output.type.kwRange.end"
                                            readonly="true"
                                        ></ion-input>
                                    </div>
                                </ion-col>
                            </ion-row>
                            <ion-row align-items-stretch>
                                <ion-col size="12" size-md="3" class="col-padding">
                                    <ion-label class="section-item" position="stacked">Output Current</ion-label>
                                    <div class="border-line-34 margin-top-10 readonly">
                                        <ion-input
                                            class="form-input"
                                            type="text"
                                            :value="output.type.currentRange.start"
                                            readonly="true"
                                        ></ion-input>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="3" class="col-padding">
                                    <ion-label class="section-item" position="stacked">No.of Charing Ports</ion-label>
                                    <div class="border-line-34 margin-top-10 readonly">
                                        <ion-input
                                            class="form-input"
                                            type="text"
                                            :value="output.ports.length"
                                            readonly="true"
                                        ></ion-input>
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="3" class="col-padding">
                                    <ion-label class="section-item" position="stacked">
                                        Status
                                        <span class="required">*</span>
                                    </ion-label>
                                    <div class="border-line-34 margin-top-10">
                                        <ion-select
                                            class="form-select"
                                            :value="outputs[index].status ? outputs[index].status.id : null"
                                            @ionChange="onSelectOutputStatusAtOutputIndex($event, index)"
                                            placeholder="Select Status"
                                        >
                                            <ion-select-option
                                            v-for="(outputStatus, outputStatusIndex) in outputStasuses"
                                            :key="outputStatusIndex"
                                            :value="outputStatus.id"
                                            >{{outputStatus.name}}</ion-select-option>
                                        </ion-select>
                                    </div>
                                </ion-col>
                            </ion-row>
                            <ion-row
                                align-items-stretch
                                v-for="(portType, portIndex) in outputs[index].ports"
                                :key="portIndex"
                            >
                                <ion-col size="12" size-md="3" class="col-padding">
                                    <ion-label class="section-item" position="stacked">Charging Port - {{portIndex + 1}}</ion-label>
                                </ion-col>
                                <ion-col size="12" size-md="3" class="col-padding">
                                    <div class="border-line-34" v-if="mode == 'ADD'">
                                        <ion-select
                                            class="form-select"
                                            :value="outputTypes[index].portTypes[portIndex].name"
                                            @ionChange="onChangePortTypeOfPortAtIndexOfOutputAtIndex($event, portIndex, index)"
                                            placeholder="Select Port"
                                            interface="popover"
                                            disabled="true"
                                        >
                                            <ion-select-option
                                            v-for="(portTypeOption, portTypeOptionIndex) in outputTypes[index].portTypes"
                                            :key="portTypeOptionIndex"
                                            :value="portTypeOption.name"
                                            >{{portTypeOption.name}}</ion-select-option>
                                        </ion-select>
                                    </div>
                                    <div class="border-line-34" v-if="mode != 'ADD'">
                                        <ion-select
                                            class="form-select"
                                            :value="outputs[index].ports[portIndex].type ? outputs[index].ports[portIndex].type : null"
                                            @ionChange="onChangePortTypeOfPortAtIndexOfOutputAtIndex($event, portIndex, index)"
                                            placeholder="Select Port"
                                            interface="popover"
                                            disabled="true"
                                        >
                                            <ion-select-option
                                            v-for="(portTypeOption, portTypeOptionIndex) in outputTypes[index].portTypes"
                                            :key="portTypeOptionIndex"
                                            :value="portTypeOption.type"
                                            >{{portTypeOption.name}}</ion-select-option>
                                        </ion-select> 
                                    </div>
                                </ion-col>
                                <ion-col size="12" size-md="3" class="col-padding">
                                    <div class="border-line-34">
                                        <ion-select
                                            class="form-select"
                                            :value="outputs[index].ports[portIndex].status ? outputs[index].ports[portIndex].status.id : null"
                                            @ionChange="onChangePortStatusOfPortAtIndexOfOutputAtIndex($event, portIndex, index)"
                                            placeholder="Select Status"
                                        >
                                            <ion-select-option
                                            v-for="(outputPortStasus, outputPortStasusIndex) in outputPortStasuses"
                                            :key="outputPortStasusIndex"
                                            :value="outputPortStasus.id"
                                            >{{outputPortStasus.name}}</ion-select-option>
                                        </ion-select>
                                    </div>
                                </ion-col>
                            </ion-row>
                            <hr class="thick-line" />
                        </div>
                    </ion-col>
                </ion-row>
                <ion-row align-items-stretch>
                    <ion-col size="12" class="col-nopadding ion-text-right" >
                        <ion-button class="btn-primary" @click="cancel">Cancel</ion-button>
                        <ion-button class="btn-primary" @click="saveCharger">Save</ion-button>
                    </ion-col>
                </ion-row>
            </form>
        </ion-grid>
        <div class="spinner">
            <ion-spinner v-if="loaderTab"></ion-spinner>
        </div>
    </div>
</template>

<script>
import { defineComponent } from "vue";
import { IonButton, IonRow, IonCol, IonGrid, IonIcon, IonInput, IonLabel, IonSelect, IonSelectOption, IonSpinner } from "@ionic/vue";
import { EVChargerService } from "../../service/evcstation/charger.service";
import {
  EVCharger,
  EVChargerStatus,
  EVChargerOutput,
  EVChargerOutputType,
  EVChargerOutputPort,
  EVChargerOutputPortType,
  EVChargerOutputStatus,
  EVChargerOutputPortStatus
} from "../../entity/station/evcharger";

import { LocalStorage } from "../../data/localstorage";
import { ToastUtils } from "../../util/toast-utils";
import { AlertUtils } from "../../util/alert-utils";
// import Datepicker from "vuejs-datepicker/dist/vuejs-datepicker.esm.js";
import datepicker from 'vue3-datepicker';
import { tryParseServiceError, migratedTryParseServiceError } from "../../service";

export default defineComponent ({
    name: 'chargerDetail',
    components: {
        datepicker, IonGrid, IonRow, IonCol, IonLabel, IonSelect, IonSelectOption, IonInput, IonButton, IonIcon, IonSpinner
    },
    data() {
        return {
            loaderTab: true,
            mode: "ADD",
            chargerId: "",

            id: "",
            manufacturer: "",
            serialNumber: "",
            type: "",
            status: "",
            primaryCommunicaiton: "",
            secondaryCommunicaiton: "",
            pndEffectiveOn: "",
            retEffectiveOn: "",
            outputs: [],

            chargerType: null,
            outputTypes: [],

            types: null,
            statuses: null,
            outputStasuses: [],
            outputPortStasuses: [],
            communicationMethods: null
        }
    },
    async mounted() {
        try {
            // this.types = await new EVChargerService().chargerTypes();
            // this.statuses = await new EVChargerService().chargerStatuses();
            // this.outputStasuses = await new EVChargerService().chargerOutputStatuses();
            // this.outputPortStasuses = await new EVChargerService().chargerOutputPortStasuses();
            this.communicationMethods = await new EVChargerService().chargerCommunicationProtocols();
            await new EVChargerService().chargerTypes().then((types) => {
                this.types = types;
            }).catch((error) => {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            })
            await new EVChargerService().chargerStatuses().then((statuses) => {
                this.statuses = statuses;
            }).catch((error) => {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            })
            await new EVChargerService().chargerOutputStatuses().then((outputStasuses) => {
                this.outputStasuses = outputStasuses;
            }).catch((error) => {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            });
            await new EVChargerService().chargerOutputPortStasuses().then((outputPortStasuses) => {
                this.outputPortStasuses = outputPortStasuses;
            }).catch((error) => {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            });
            await new EVChargerService().chargerCommunicationProtocols().then((communicationMethods) => {
                this.communicationMethods = communicationMethods;
            }).catch((error) => {
                this.loaderTab = false;
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            });

            if (this.$route.params.chargerId) {
                // let charger = await new EVChargerService().chargerWithId(
                //     this.$route.params.chargerId
                // );
                // this.fillCharger(charger);
                await new EVChargerService().chargerWithId(this.$route.params.chargerId).then((charger) => {
                    this.fillCharger(charger);
                })
            }
            this.loaderTab = false;
        } catch(error) {
            this.loaderTab = false;
            let serviceError = migratedTryParseServiceError(error);
            new ToastUtils().presentToast(serviceError.description);
        }
        
    },
    methods: {
        changeChargerType(event) {
            this.type = event.target.value;
            if (!this.chargerType || this.type !== this.chargerType.id) {
                if (this.mode == "ADD") {
                    let chargerType = this.types.find(
                        chargerType => chargerType.id === this.type
                    );
                    this.chargerType = chargerType;
                    this.outputTypes = chargerType.outputTypes;
                    //initiating outputs
                    this.outputs = [];
                    this.outputTypes.forEach(outputType => {
                        let ports = [];
                        outputType.portTypes.forEach(portType => {
                            ports.push(new EVChargerOutputPort(0, portType.name, undefined));
                        });
                        this.outputs.push(
                        // below code is commented by vinoth on 29.04.2021 as per requirements
                        // new EVChargerOutput(0, outputType.id, '', outputType, ports, null)
                        new EVChargerOutput(0, outputType.id, outputType, ports, null)
                        );
                    });
                }
            }
        },
        getPortName(name) {
        return name.name;
        },
        onChangeNoOfPortSelectionForOutputAtIndex(event, noOfPorts, outputIndex) {
        if (noOfPorts > this.outputs[outputIndex].ports.length) {
            for (
            let i = this.outputs[outputIndex].ports.length;
            i < noOfPorts;
            i++
            ) {
            this.outputs[outputIndex].ports.push(
                new EVChargerOutputPort(0, "", undefined)
            );
            }
        }
        },

        onSelectOutputStatusAtOutputIndex(event, outputIndex) {
        this.outputs[outputIndex].status = new EVChargerOutputStatus(
            event.target.value,
            ""
        );
        },

        onChangePortStatusOfPortAtIndexOfOutputAtIndex(
        event,
        portIndex,
        outputIndex
        ) {
        this.outputs[outputIndex].ports[
            portIndex
        ].status = new EVChargerOutputPortStatus(event.target.value, "");
        },
        onChangePortTypeOfPortAtIndexOfOutputAtIndex(
        event,
        portIndex,
        outputIndex
        ) {
        this.outputs[outputIndex].ports[portIndex].type = event.target.value;
        },
        outputPorts(portTypes) {
        let ports = [];
        portTypes.forEach(portType => {
            let port = new EVChargerOutputPort(
            portType.id,
            portType.name,
            new EVChargerOutputPortStatus(portType.status, "")
            );
            ports.push(port);
        });
        return ports;
        },

        fillCharger(charger) {
        this.mode = "UPDATE";
        this.chargerId = charger.id;
        this.id = charger.id;
        this.manufacturer = charger.manufacturer;
        this.serialNumber = charger.serialNumber;
        this.type = charger.type.id;
        this.status = charger.status.id;
        this.primaryCommunicaiton = charger.primaryCommunicaiton.id;
        this.secondaryCommunicaiton = charger.secondaryCommunicaiton.id;
        this.pndEffectiveOn = charger.pndEffectiveOn;
        this.retEffectiveOn = charger.retEffectiveOn;

        let chargerType = this.types.find(
            chargerType => chargerType.id === charger.type.id
        );
        this.chargerType = chargerType;

        this.outputTypes = chargerType.outputTypes;

        //initiating outputs
        this.outputs = charger.outputs;
        },

        cancel() {
        this.$router.back();
        },

        async saveCharger() {
            try {
                if (
                typeof this.manufacturer === "undefined" ||
                this.manufacturer === null ||
                this.manufacturer === "" ||
                this.manufacturer.trim().length === 0
                ) {
                new ToastUtils().presentToast("Enter Charger Manufacturer");
                } else if (
                typeof this.serialNumber === "undefined" ||
                this.serialNumber === null ||
                this.serialNumber === "" ||
                this.serialNumber.trim().length === 0
                ) {
                new ToastUtils().presentToast("Enter Serial Number");
                } else if (
                typeof this.type === "undefined" ||
                this.type === null ||
                this.type === ""
                ) {
                new ToastUtils().presentToast("Select Charger Type");
                } else if (
                typeof this.primaryCommunicaiton === "undefined" ||
                this.primaryCommunicaiton === null ||
                this.primaryCommunicaiton === ""
                ) {
                new ToastUtils().presentToast("Select Primary Communicaiton");
                } else if (
                typeof this.secondaryCommunicaiton === "undefined" ||
                this.secondaryCommunicaiton === null ||
                this.secondaryCommunicaiton === ""
                ) {
                new ToastUtils().presentToast("Select Secondary Communicaiton");
                } else {
                let charger = null;
                let primaryComm = this.communicationMethods.find(
                    communicationMethod =>
                    communicationMethod.id === this.primaryCommunicaiton
                );
                let secondaryComm = this.communicationMethods.find(
                    communicationMethod =>
                    communicationMethod.id === this.secondaryCommunicaiton
                );
                if (this.mode === "ADD") {
                    charger = new EVCharger(
                    this.id,
                    this.manufacturer,
                    this.serialNumber,
                    this.chargerType,
                    new EVChargerStatus(this.status, "")
                    );
                    charger.primaryCommunicaiton = primaryComm;
                    charger.secondaryCommunicaiton = secondaryComm;
                    charger.pndEffectiveOn = this.pndEffectiveOn
                    ? new Date(this.pndEffectiveOn)
                    : null;
                    charger.retEffectiveOn = this.retEffectiveOn
                    ? new Date(this.retEffectiveOn)
                    : null;
                    charger.outputs = this.outputs;
                    await new EVChargerService().createChargerByAuthor(
                    charger,
                    new LocalStorage().user
                    );
                } else {
                    charger = new EVCharger(
                    this.chargerId,
                    this.manufacturer,
                    this.serialNumber,
                    this.chargerType,
                    new EVChargerStatus(this.status, "")
                    );
                    charger.primaryCommunicaiton = primaryComm;
                    charger.secondaryCommunicaiton = secondaryComm;
                    charger.pndEffectiveOn = this.pndEffectiveOn
                    ? new Date(this.pndEffectiveOn)
                    : null;
                    charger.retEffectiveOn = this.retEffectiveOn
                    ? new Date(this.retEffectiveOn)
                    : null;
                    charger.outputs = this.outputs;
                    await new EVChargerService().updateChargerByAuthor(
                    charger,
                    new LocalStorage().user
                    );
                }
                new ToastUtils().presentToast("Charger saved successfully");
                this.$router.back();
                }
            } catch (error) {
                // let serviceError = tryParseServiceError(error);
                // new AlertUtils().presentAlert(serviceError ? serviceError : error);
                // new ToastUtils().presentToast(error.response.data.errors[0].detail);
                let serviceError = migratedTryParseServiceError(error);
                new ToastUtils().presentToast(serviceError.description);
            }
        }
    }
})
</script>

<style scoped>
.readonly {
  background: #f8f8f8 0% 0% no-repeat padding-box;
}
</style>